/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesHOpenIcon24Solid = forwardRef('ArrowCollapseTrianglesHOpenIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m16.987 4.487 4.861 4.861a3.75 3.75 0 0 1 0 5.303l-4.86 4.861C15.884 20.615 14 19.834 14 18.275V5.725c0-1.56 1.885-2.34 2.987-1.238Z" }),
        React.createElement("path", { d: "m2.152 9.348 4.86-4.86C8.115 3.384 10 4.165 10 5.724v12.55c0 1.559-1.885 2.34-2.988 1.237l-4.86-4.86a3.75 3.75 0 0 1 0-5.304Z" })));
});
